import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/_sidebar-layout/seo-strategy/')({
  beforeLoad: function () {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/app', replace: true });
  },
  component: function () {
    return null;
  },
});
